export default __webpack_public_path__ + "05fa60ac02170399d47a75ff12c53863.webp";